export const CHECK_DEALS = `
  mutation CheckDeals($id: ID!) {
    checkDeals(id: $id){
      result
      errors {
          property
          description
      }
    }
  }
`;

export const ASSIGN_ATTACHMENT_TO_REDEMPTION_REQUEST = `
  mutation AssignAttachmentsToCustomerRedemptionResquest($attachmentIds: [ID!]!, $redemptionRequestId: ID!) {
    assignAttachmentsToRedemptionRequest(attachmentIds: $attachmentIds, redemptionRequestId: $redemptionRequestId) {
      redemptionRequest {
        id
        redemptionRequestAttachments {
          id
          attachment {
            id
            url
          }
        }
      }

    }
  }
`;

export const ASSIGN_NOTE_TO_REDEMPTION_REQUEST = `
  mutation AssignNoteToCompanyRedemptionResquest($noteId: ID!, $redemptionRequestId: ID!){
    assignNoteToRedemptionRequest(noteId: $noteId, redemptionRequestId: $redemptionRequestId) {
      redemptionRequestNote {
        id
        note {
          id
          description
          createdAt
          updatedAt
          user {
            id
            name
          }
        }
      }
    }
  }
`;

export const GET_REDEMPTION_REQUEST = `
query GetCustomerRedemptionRequest($id:ID!){
  redemptionRequest(id: $id ) {
    id
    requestDate
    valueDate
    paidDate
    correctInfoDate
    redemptionType
    redemptionValue
    paymentMode
    canTransitionToNextStates
    redemptionAmount
    initialRedemptionAmount
    amountPaid
    contactInformation
    withholdingTax
    externalReference
    unvestedExternalReference
    expectsUnvestedDeal
    dueDate
    amountPaid
    platformFee
    unvestedUnassigned
    additionalData
    deal {
      clientPetraid
      contributions
      createdAt
      customerPetraid
      dealDescription
      dealType
      id
      notificationProcessedAt
      priceDate
      relatedPaymentId
      relatedScheduleId
      shareClass
      shareClassId
      status
      taId
      totalAmount
      totalUnits
      transactionId
      transactionType
      updatedAt
    }
    unvestedDeal {
      clientPetraid
      contributions
      createdAt
      customerPetraid
      dealDescription
      dealType
      id
      notificationProcessedAt
      priceDate
      relatedPaymentId
      relatedScheduleId
      shareClass
      shareClassId
      status
      taId
      totalAmount
      totalUnits
      transactionId
      transactionType
      updatedAt
    }
    isFormerCompany
    allocationAmountBreakdown
    taTransactionStatus
    clientContactInformation
    initiator
    riskBreakdown
    dealProcessed
    notifierRecords {
      id
      notificationType
      status
      message
      recipient
      reference
      createdAt
      updatedAt
      customer {
        id
        petraId
      }
      company {
        id
        petraId
      }
    }
    customerSubscription {
      id
      product {
        id
        name
        fundCode
      }
    }
    redemptionRequestNotes {
      id
      note {
        id
        description
        createdAt
        updatedAt
        user {
          id
          name
        }
      }
      redemptionRequestNoteTickets {
        id
        ticket {
          id
          properties
          reference
          source
          url
          number
        }
      }
    }
    customer {
        id
        firstName
        middleName
        lastName
        petraId
    }
    redemptionRequestAttachments {
      id
      attachment {
        id
        url
        name
      }
    }
    state
    source
    batchNumber
    company {
      id
      name
      petraId
    }
    redemptionRequestPurpose {
      id
      name
    }
    redemptionRequestSubPurpose {
      redemptionRequestSubPurposeItem {
        id
        name
      }
    }
    redemptionRequestFollowers {
      id,
      user {
        id,
        name
      }
    }
    redemptionRequestReason {
      id
      reason {
        id
        reasonDescription
      }
    }
    payoutAccount{
      id
      name
      accountNumber
      accountType
      isPayoutAccountVerified
      bankBranch {
        id
        name
        sortCode
        financialInstitution {
          id
          name
        }
      }
    }
    totalAmountType
    idType {
      id
      name
    }
    idNumber
    idUrl
    vestingValueType
    vestingValue
    vestingRuleUrl
    taxWaiverNpraUrl
    authorizer {
      id
      contactName
      emailAddress
    }
    transferRequest {
      id
    }
    subCategory {
      id
      name
    }
    user {
      id
      name
    }
    createdAt
    updatedAt
  }
}
`;


export const GET_REDEMPTION_REQUEST_REASONS = `
query GetRedemptionRequestReasons($state:String!){
  redemptionRequestReasons(state: $state ) {
    id
    reason {
      id
      reasonDescription
      reasonKey
    }
    state
  }
}
`;

export const ASSIGN_FOLLOWERS_TO_REDEMPTIONS_REQUEST = `
mutation AssignFollowersToRedemptionRequest($redemptionRequestId: ID!, $userIds:[ID!]!){
  assignFollowersToRedemptionRequest(redemptionRequestId: $redemptionRequestId, userIds: $userIds){
    redemptionRequest {
      id
    }
    errors {
      property
      description
    }
  }
}
`;

export const GET_REDEMPTION_REQUEST_LOGS = `
query RedemptionRequestChangeLogs($redemptionRequestId: ID!) {
  redemptionRequestChangeLogs(redemptionRequestId: $redemptionRequestId) {
    audits {
      auditItem
      createdAt
      action
      newValue
      oldValue
      user
      comment
    }
    stateAudits {
      auditItem
      createdAt
      action
      newValue
      oldValue
      user
      comment
    }
  }
}
`;

export const CREATE_NOTE_TICKET = `
mutation CreateRedemptionRequestNoteTicket($source: String!, $properties: JSON!, $redemptionRequestNoteId: String!, $ticketSubCategoryId: ID) {
  createRedemptionRequestNoteTicket(source: $source, properties: $properties, redemptionRequestNoteId: $redemptionRequestNoteId, ticketSubCategoryId: $ticketSubCategoryId){
    ticket {
      id
      properties
      reference
      source
      url
    }
    errors {
      property
      description
    }
  }
}
`;

export const GET_REDEMPTION_REQUEST_FOR_EDIT = `
query GetCustomerRedemptionRequest($id: ID!) {
  redemptionRequest(id: $id) {
    id
    requestDate
    valueDate
    paidDate
    correctInfoDate
    initiator
    clientContactInformation
    redemptionType
    externalReference
    redemptionValue
    redemptionAmount
    amountPaid
    contactInformation
    paymentMode
    unvestedUnassigned
    isManualAllocation
    waiveOffTax
    withholdingTax
    unvestedEmployerPostTax
    unvestedEmployerPreTax
    manualContribution
    manualEmployerPreTax
    manualEmployerPostTax
    manualEmployeePreTax
    manualEmployeePostTax
    manualWithholdingTax
    state
    additionalData
    isFormerCompany
    customerSubscription {
      id
      product {
        id
        name
        fundCode
        taxWaiverRequired
      }
    }
    redemptionRequestNotes {
      id
      note {
        id
        description
        user {
          id
          name
        }
      }
      redemptionRequestNoteTickets {
        id
        ticket {
          id
          properties
          reference
          source
          url
          number
        }
      }
    }
    customer {
      id
      firstName
      middleName
      lastName
      petraId
      activeCustomerPhones {
        id
        phone {
          id
          number
          type
        }
        isPrimary
      }
      customerEmails {
        id
        isPrimary
        email {
          id
          address
        }
      }
      customerSubscriptions {
        id
        product {
          id
          name
          fundCode
          taxWaiverRequired
          productTier {
            id
            name
          }
          productCategory {
            id
            name
          }
          assetMapId
        }
        customerPayoutAccounts {
          id
          accountNumber
          name
          accountType
          institutionName
          isPayoutAccountVerified
          payoutAccountVerifiedAt
          bankBranch {
            id
            name
            financialInstitution {
              id
              name
            }
          }
          payoutAccount {
            id
            name
            accountNumber
            accountType
            bankBranch {
              id
              name
              financialInstitution {
                id
                name
              }
            }
          }
        }
        productDuration
      }
      customerPayoutAccounts {
        id
        accountNumber
        name
        accountType
        institutionName
        isPayoutAccountVerified
        payoutAccountVerifiedAt
        bankBranch {
          id
          name
          financialInstitution {
            id
            name
          }
        }
      }
      customerCompanyAssociations {
        company {
          id
          name
        }
      }
      employers {
        id
        name
        industrySector {
          name
        }
        petraId
        tinNumber
      }
      formerCompanies {
        id
        name
        industrySector {
          name
        }
        petraId
        tinNumber
      }
    }
    redemptionRequestAttachments {
      id
      attachment {
        id
        url
      }
    }
    state
    source
    batchNumber
    company {
      id
      name
      petraId
    }
    redemptionRequestPurpose {
      id
      name
    }
    redemptionRequestSubPurpose {
      redemptionRequestSubPurposeItem {
        id
        name
      }
    }
    redemptionRequestFollowers {
      id
      user {
        id
        name
      }
    }
    redemptionRequestReason {
      id
      reason {
        id
        reasonDescription
      }
    }
    payoutAccount {
      id
      name
      accountNumber
      accountType
      isPayoutAccountVerified
      bankBranch {
        id
        name
        financialInstitution {
          id
          name
        }
      }
    }
    totalAmountType
    idType {
      id
      name
    }
    idNumber
    idUrl
    vestingValueType
    vestingValue
    vestingRuleUrl
    taxWaiverNpraUrl
    transferRequest {
      id
    }
    subCategory {
      id
      name
    }
    user {
      id
      name
    }
    createdAt
    updatedAt
  }
}
`;

export const UPDATE_REDEMPTION_REQUEST = `
mutation UpdateCustomerRedemptionRequest($id: ID!, $userId: ID, $customerId: ID, $companyId: ID, $customerSubscriptionId: ID, $idTypeId: ID, $idNumber: String, $redemptionType: String, $requestDate: String, $redemptionRequestReason: ID, $accountType: String, $newPayoutAccount: Boolean, $bankBranchId: ID, $name: String, $accountNumber: String, $subCategoryId: ID, $redemptionValue: Float, $correctInfoDate: String, $paymentMode: String, $payoutAccountId: ID, $contactInformation: String, $unvestedUnassigned: Float, $isManualAllocation: Boolean, $manualContribution: Float, $manualEmployerPreTax: Float, $manualEmployerPostTax: Float, $manualEmployeePreTax: Float, $manualEmployeePostTax: Float, $manualWithholdingTax: Float, $additionalPurposeDescription: String, $isFormerCompany: Boolean!, $waiveOffTax: Boolean, $taxWaiverNpraUrl: String, $savePayoutAccount: Boolean!, $totalAmountType: String, $checklist: [String!]!, $redemptionRequestPurposeId: ID, $redemptionRequestSubPurposeId: ID, $unvestedEmployerPostTax: Float, $unvestedEmployerPreTax: Float, $clientContactInformation: String){
  updateRedemptionRequest(id: $id, userId: $userId, customerId: $customerId, companyId: $companyId, customerSubscriptionId: $customerSubscriptionId, idTypeId: $idTypeId, idNumber: $idNumber, redemptionType: $redemptionType, requestDate: $requestDate, redemptionRequestReason: $redemptionRequestReason, accountType :$accountType, newPayoutAccount: $newPayoutAccount, bankBranchId: $bankBranchId, name: $name, accountNumber: $accountNumber, subCategoryId: $subCategoryId, redemptionValue:$redemptionValue, correctInfoDate: $correctInfoDate, paymentMode: $paymentMode, payoutAccountId: $payoutAccountId, contactInformation: $contactInformation, unvestedUnassigned: $unvestedUnassigned, isManualAllocation: $isManualAllocation, manualContribution: $manualContribution, manualEmployerPreTax: $manualEmployerPreTax, manualEmployerPostTax: $manualEmployerPostTax, manualEmployeePreTax: $manualEmployeePreTax, manualEmployeePostTax: $manualEmployeePostTax, manualWithholdingTax: $manualWithholdingTax, additionalPurposeDescription: $additionalPurposeDescription, isFormerCompany: $isFormerCompany, waiveOffTax: $waiveOffTax, taxWaiverNpraUrl: $taxWaiverNpraUrl, savePayoutAccount: $savePayoutAccount, totalAmountType: $totalAmountType, checklist: $checklist, redemptionRequestPurposeId: $redemptionRequestPurposeId, redemptionRequestSubPurposeId: $redemptionRequestSubPurposeId,unvestedEmployerPreTax: $unvestedEmployerPreTax,  unvestedEmployerPostTax: $unvestedEmployerPostTax, clientContactInformation: $clientContactInformation) {
     redemptionRequest {
      id
      requestDate
      valueDate
      correctInfoDate
      redemptionType
      amountPaid
      paymentMode
      contactInformation
      unvestedUnassigned
      isManualAllocation
      manualContribution
      manualEmployerPreTax
      manualEmployerPostTax
      manualEmployeePreTax
      manualEmployeePostTax
      manualWithholdingTax
      customer {
          id
          firstName
      }
      customerSubscription {
        id
      }
      idType {
        id
        name
      }
      idNumber
      idUrl
    }
    errors{
      description
      property
    }
  }
 }
`;

export const GET_REDEMPTION_PURPOSES = `
  query RedemptionRequestPurposes($productId: ID!) {
    redemptionRequestPurposes(productId: $productId) {
      id
      name
    }
  }
`;

export const GET_REDEMPTION_CHECKLIST = `
  query RedemptionRequestChecklist($productId: ID!, $redemptionRequestPurposeId: ID!) {
    redemptionRequestChecklist(productId: $productId, redemptionRequestPurposeId: $redemptionRequestPurposeId) {
      name
      isRequired
    }
  }
`;

export const GET_REDEMPTION_SUB_PURPOSES = `
  query RedemptionRequestSubPurposes($productId: ID!, $redemptionRequestPurposeId: ID!) {
    redemptionRequestSubPurposes(productId: $productId, redemptionRequestPurposeId: $redemptionRequestPurposeId) {
      id
      name
    }
  }
`;

export const SEARCH_REDEMPTION_REQUEST_FOR_EDIT = `
query RedemptionRequestSearch($q: String!, $page: ID!){
  redemptionRequestSearch(q: $q, page: $page) {
    count
    results {
      id
      requestDate
      valueDate
      redemptionType
      redemptionValue
      redemptionAmount
      state
      company {
        id
        name
      },
      customer {
        id
        middleName
        firstName
        lastName
        petraId
      }
      customerSubscription {
        id
      }
    }
    errors {
      property
      description
    }
  }
}
`;

export const GET_REDEMPTION_REQUEST_STATE_ENUM = `
{
  __type(name: "RedemptionRequestStateEnum") {
    enumValues {
      name
      description
    }
  }
}
`;

export const GET_REDEMPTION_REQUEST_SORT_FIELDS = `
{
  __type(name: "RedemptionRequestSortFieldEnum") {
    enumValues {
      name
      description
    }
  }
}
`;

export const SEARCH_REDEMPTION_REQUEST = `
query RedemptionRequestSearch($q: String!, $page: ID!, $numberPerPage: ID, $states: [RedemptionRequestStateEnum!], $orderBy: RedemptionRequestOrderByInput){
  redemptionRequestSearch(q: $q, page: $page, numberPerPage: $numberPerPage, states: $states, orderBy: $orderBy) {
    count
    results {
      id
      redemptionType
      redemptionValue
      redemptionAmount
      state
      source
      batchNumber
      requestDate
      customerSubscription {
        id
        product {
          id
          name
          fundCode
        }
      }
      company {
        id
        name
        petraId
      }
      customer {
        id
        middleName
        firstName
        lastName
        petraId
      }
    }
    errors {
      property
      description
    }
  }
}
`;

export const GLOBAL_SEARCH_REDEMPTION_REQUEST = `
query GlobalSearchRedemptionRequest($q: String!, $page: ID!, $numberPerPage: ID){
  redemptionRequestSearch(q: $q, page: $page, numberPerPage: $numberPerPage) {
    count
    results {
      id
      redemptionAmount
      requestDate
      customer {
        id
        firstName
        middleName
        lastName
      }
    }
    errors {
      property
      description
    }
  }
}
`;

export const CREATE_REDEMPTION_REQUEST = `
 mutation CreateCustomerRedemptionRequest($customerId: ID!, $companyId: ID!, $redemptionType: ID!, $redemptionValue: Float!, $requestDate: String!, $payoutAccountId: ID, $customerSubscriptionId: ID!, $redemptionRequestPurposeId: ID!, $redemptionRequestSubPurposeId: ID, $contactInformation: String, $idTypeId: ID!, $idNumber: String!, $includeVestingRule: Boolean!, $vestingValue: String, $vestingRuleUrl: String, $totalAmountType: String!, $waiveOffTax: Boolean!, $taxWaiverNpraUrl: String, $newPayoutAccount: Boolean!, $bankBranchId: ID, $name: String, $accountNumber: String, $accountType: String, $subCategoryId: ID!, $userId: ID, $paymentMode: String, $additionalPurposeDescription: String, $isFormerCompany: Boolean!, $savePayoutAccount: Boolean!, $checklist: [String!]!, $attachmentIds: [ID!]!, $initiator: String!, $clientContactInformation: String, $authorizerCompanyContactId: ID){
   createRedemptionRequest(customerId: $customerId, companyId: $companyId, redemptionType: $redemptionType, redemptionValue: $redemptionValue, requestDate: $requestDate, customerSubscriptionId: $customerSubscriptionId, payoutAccountId: $payoutAccountId, redemptionRequestPurposeId: $redemptionRequestPurposeId, redemptionRequestSubPurposeId:$redemptionRequestSubPurposeId, contactInformation: $contactInformation, idTypeId: $idTypeId, idNumber: $idNumber, includeVestingRule: $includeVestingRule, vestingValue: $vestingValue, vestingRuleUrl: $vestingRuleUrl, totalAmountType: $totalAmountType, waiveOffTax: $waiveOffTax, taxWaiverNpraUrl: $taxWaiverNpraUrl, newPayoutAccount: $newPayoutAccount, accountNumber: $accountNumber, name: $name, accountType: $accountType, bankBranchId: $bankBranchId, subCategoryId: $subCategoryId, userId: $userId, paymentMode: $paymentMode, additionalPurposeDescription: $additionalPurposeDescription, isFormerCompany: $isFormerCompany, savePayoutAccount: $savePayoutAccount, checklist: $checklist, attachmentIds: $attachmentIds, initiator: $initiator, clientContactInformation: $clientContactInformation, authorizerCompanyContactId: $authorizerCompanyContactId) {
     redemptionRequest {
      id
      requestDate
      valueDate
      redemptionType
      paymentMode
      customer {
          id
          firstName
      }
      customerSubscription {
        id
      }
      idType {
        id
        name
      }
      idNumber
      idUrl
    }
    errors{
      description
      property
    }
  }
 }
`;


export const MOVE_REDEMPTION_REQUEST_TO_STATE = `
 mutation MoveRedemptionRequestToState($redemptionRequestId: ID!, $redemptionRequestReasonId: ID, $comment: String, $state: String!, $paidDate: String, $amountPaid: Float, $valueDate: String, $notifyCustomer: Boolean!, $notifyClient: Boolean!, $vestingValue: Float, $vestingRuleUrl: String){
   moveRedemptionRequestToState(redemptionRequestId: $redemptionRequestId, redemptionRequestReasonId: $redemptionRequestReasonId, comment: $comment, state: $state, paidDate: $paidDate, amountPaid: $amountPaid, valueDate: $valueDate, notifyCustomer: $notifyCustomer, notifyClient: $notifyClient, vestingValue: $vestingValue, vestingRuleUrl: $vestingRuleUrl) {
    redemptionRequest {
      id
      requestDate
      valueDate
      redemptionType
      paidDate
      amountPaid
      paymentMode
      customer {
        id
        firstName
      }
      customerSubscription {
        id
      }
      idType {
        id
        name
      }
      idNumber
      idUrl
    }
    errors{
      description
      property
    }
  }
 }
`;

export const GET_REQUEST_NOTIFIER_RECORDS_QUERY = `
query GetRedemptionRequest($redemptionRequestId: ID!) {
  redemptionRequest(id: $redemptionRequestId) {
    notifierRecords {
      id
      notificationType
      status
      message
      recipient
      reference
      createdAt
      updatedAt
      customer {
        id
        petraId
      }
      company {
        id
        petraId
      }
    }
  }
}
`;
